var _title, _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgIconComentar = function SvgIconComentar(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 26.9 23.6",
    style: {
      enableBackground: "new 0 0 26.9 23.6"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "icon_comentar")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_x2F_communication_x2F_chat_x5F_bubble_x5F_outline_x5F_24px"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-1_1_",
    d: "M21.1,2.3H5.9c-1,0-1.9,0.9-1.9,1.9v17.1l3.8-3.8h13.3c1,0,1.9-0.9,1.9-1.9V4.2C23,3.1,22.1,2.3,21.1,2.3z  M20.1,15.6H7.8l-1.9,1.9V5.1c0-0.5,0.4-1,1-1h13.3c0.5,0,1,0.4,1,1v9.5C21.1,15.2,20.7,15.6,20.1,15.6z"
  }))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconComentar, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_comentar.6e354155.svg";
export { ForwardRef as ReactComponent };